import { useMatches, Link } from "@tanstack/react-router";
import { Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "./ui/breadcrumb";
import { groups } from "@/components/sidebar/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";

// Get the sidebar group title
function getSidebarGroupTitle(pathname: string): string | null {
  for (const group of groups) {
    for (const item of group.items) {
      if (item.url && pathname.startsWith(item.url)) return group.title || null;
      if (item.items) {
        for (const subItem of item.items) {
          if (subItem.url && pathname.startsWith(subItem.url)) return group.title || null;
        }
      }
    }
  }
  return null;
}

export function DynamicBreadcrumbs() {
  const matches = useMatches();
  const currentMatch = matches[matches.length - 1];
  const pathname = currentMatch?.pathname ?? "/";
  const groupTitle = getSidebarGroupTitle(pathname);
  const isMobile = useIsMobile();

  const breadcrumbMatches = matches.filter((match: any) => match.loaderData?.crumb);

  // Don't render anything until device detection is complete to prevent flicker
  if (isMobile === undefined) {
    return null;
  }

  // On mobile, show only the last two breadcrumbs
  const visibleBreadcrumbs = isMobile === true ? breadcrumbMatches.slice(-2) : breadcrumbMatches;

  if (visibleBreadcrumbs.length === 0) return null;

  return (
    <Breadcrumb className="pt-2">
      <BreadcrumbList>
        {isMobile !== true && groupTitle && (
          <>
            <BreadcrumbItem>
              <span>{groupTitle}</span>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
          </>
        )}

        {visibleBreadcrumbs.map((match: any, index) => {
          const isLast = index === visibleBreadcrumbs.length - 1;
          const crumb = match.loaderData?.crumb;
          const href = match.fullPath;

          return (
            <span key={href || crumb} className="flex items-center gap-1">
              {!isLast ? (
                <>
                  <BreadcrumbItem>
                    <Link to={href} className="hover:underline">
                      {crumb}
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator />
                </>
              ) : (
                <BreadcrumbPage className={isMobile === true ? "font-semibold" : ""}>{crumb}</BreadcrumbPage>
              )}
            </span>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
